import React from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'react-bootstrap';
import { FormattedMessage, injectIntl } from 'react-intl';
import { intlShape } from '../prop-types';

const ModalForm = (props) => {
  const {
    reject,
    confirm,
    children,
    modalOpen,
    dialogClassName,
    typeButton,
    pristine,
    invalid,
    handleSubmit,
    headerMessage,
    intl: { formatMessage },
  } = props;

  const header = formatMessage({
    id: headerMessage,
    defaultMessage: 'MODAL_FORM_HEADER_MESSAGE',
  });

  return (
    <Modal dialogClassName={`${dialogClassName || ''} remove-modal`} show={modalOpen} onHide={reject}>
      <form onSubmit={handleSubmit(confirm)}>
        <Modal.Header closeButton>
          <h4 className="sentence-capitalized no-margin">
            {header}
          </h4>
        </Modal.Header>
        <Modal.Body>
          <div className="panel panel-no-border">
            <div className="panel-body">{children}</div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <div className="">
            <FormattedMessage id="actions.cancel" defaultMessage="Cancel">
              {text => (
                <button type="button" className="btn btn-sm btn-default" onClick={reject}>
                  {text}
                </button>
              )}
            </FormattedMessage>
            &nbsp;
            <FormattedMessage id="actions.delete" defaultMessage="Delete">
              {text => (
                <button type="submit" className={`btn btn-sm ${typeButton}`} disabled={pristine || invalid}>
                  {text}
                </button>
              )}
            </FormattedMessage>
          </div>
        </Modal.Footer>
      </form>
    </Modal>
  );
};

ModalForm.propTypes = {
  children: PropTypes.objectOf(PropTypes.any).isRequired,
  reject: PropTypes.func.isRequired,
  confirm: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  modalOpen: PropTypes.bool,
  dialogClassName: PropTypes.string,
  headerMessage: PropTypes.string.isRequired,
  typeButton: PropTypes.string,
  pristine: PropTypes.bool,
  invalid: PropTypes.bool,
  intl: intlShape.isRequired,
};

ModalForm.defaultProps = {
  modalOpen: false,
  pristine: false,
  invalid: false,
  dialogClassName: null,
  typeButton: null,
};

export default injectIntl(ModalForm);
